import React from 'react';
import { BookOpen, Check, User, Mail } from 'lucide-react';

const EbookMagnet = () => (
  <section className="py-16 md:py-20 bg-white border-t border-green-100">
    <div className="max-w-2xl mx-auto px-4 md:px-6">
      {/* Problem Heading */}
      <div className="text-center mb-4">
        <h1 className="text-3xl md:text-5xl font-extrabold text-green-800 mb-3">THE AI REVOLUTION: HOW SMART COACHES ARE BOOKING 2X MORE CLIENTS WITH HALF THE EFFORT</h1>
        <p className="text-lg md:text-2xl text-green-600 mb-6">Discover the insider strategies that top wellness professionals are using to automate their marketing, client management, and content creation—all without hiring a team.</p>
      </div>
      {/* Inviting Image */}
      <div className="flex justify-center mb-8">
        <img src="https://images.unsplash.com/photo-1519389950473-47ba0277781c?auto=format&fit=crop&w=600&q=80" alt="AI Ebook" className="rounded-xl shadow-lg w-full max-w-md object-cover" />
      </div>
      {/* Form Section */}
      <div className="bg-white rounded-xl shadow-md p-6 mb-10">
        <h4 className="text-lg font-semibold text-green-800 mb-4">📚 Get Your FREE 27-Page Strategy Guide</h4>
        <form className="flex flex-col gap-4">
          <div className="flex items-center border rounded-lg px-3 py-2 bg-green-50">
            <User className="w-5 h-5 text-green-400 mr-2" />
            <input type="text" placeholder="First Name" className="bg-transparent flex-1 outline-none text-green-900" required />
          </div>
          <div className="flex items-center border rounded-lg px-3 py-2 bg-green-50">
            <Mail className="w-5 h-5 text-green-400 mr-2" />
            <input type="email" placeholder="Email Address" className="bg-transparent flex-1 outline-none text-green-900" required />
          </div>
          <div className="flex items-center border rounded-lg px-3 py-2 bg-green-50">
            <select className="bg-transparent flex-1 outline-none text-green-900" required defaultValue="">
              <option value="" disabled>Your Specialty</option>
              <option>Nutrition</option>
              <option>Fitness</option>
              <option>Mindfulness</option>
              <option>Holistic Health</option>
              <option>Life Coaching</option>
              <option>Other</option>
            </select>
          </div>
          <button type="submit" className="mt-2 px-6 py-3 bg-green-400 text-white text-lg font-bold rounded-lg shadow-lg hover:bg-green-500 transition duration-300">
            SEND MY GUIDE NOW
          </button>
        </form>
      </div>
      {/* Offer Section */}
      <div className="bg-green-50 rounded-xl shadow-lg overflow-hidden mb-10 md:mb-14">
        <div className="p-6 md:p-8 flex flex-col items-center">
          <BookOpen className="w-10 h-10 text-green-400 mb-4" strokeWidth={1.5} />
          <h3 className="text-xl font-bold text-green-800 mb-2">Inside This Practical Guide:</h3>
          <ul className="mt-4 space-y-2 text-left">
            <li className="flex items-start"><Check className="w-5 h-5 text-green-400 mr-2 flex-shrink-0 mt-0.5" /><span className="text-green-700 text-sm">The 5-step client acquisition system that works while you sleep</span></li>
            <li className="flex items-start"><Check className="w-5 h-5 text-green-400 mr-2 flex-shrink-0 mt-0.5" /><span className="text-green-700 text-sm">How to create personalized nutrition plans in minutes, not hours</span></li>
            <li className="flex items-start"><Check className="w-5 h-5 text-green-400 mr-2 flex-shrink-0 mt-0.5" /><span className="text-green-700 text-sm">Case study: How Maria automated her entire client onboarding process</span></li>
            <li className="flex items-start"><Check className="w-5 h-5 text-green-400 mr-2 flex-shrink-0 mt-0.5" /><span className="text-green-700 text-sm">The exact AI prompts top coaches use to create content that converts</span></li>
          </ul>
          <div className="mt-4 text-green-700 font-semibold">Limited Time: Get the bonus "30-Day AI Implementation Calendar" when you download today!</div>
        </div>
      </div>
      {/* Testimonials Section */}
      <div className="mt-12">
        <h4 className="text-xl font-bold text-green-800 mb-6 text-center">What Smart Coaches Are Saying</h4>
        <div className="relative">
          <div className="flex overflow-x-auto gap-4 pb-4 snap-x snap-mandatory scrollbar-hide">
            <div className="flex-none w-[80%] snap-start">
              <div className="bg-green-50 rounded-lg p-5 shadow flex flex-col h-full">
                <p className="text-green-900 italic mb-2">"The AI tips in this ebook helped me automate my marketing and free up my time!"</p>
                <span className="text-green-700 font-semibold">— Alex R., Nutrition Coach</span>
              </div>
            </div>
            <div className="flex-none w-[80%] snap-start">
              <div className="bg-green-50 rounded-lg p-5 shadow flex flex-col h-full">
                <p className="text-green-900 italic mb-2">"I finally understand how to use technology to grow my business. Highly recommended!"</p>
                <span className="text-green-700 font-semibold">— Priya S., Wellness Consultant</span>
              </div>
            </div>
            <div className="flex-none w-[80%] snap-start">
              <div className="bg-green-50 rounded-lg p-5 shadow flex flex-col h-full">
                <p className="text-green-900 italic mb-2">"This guide transformed how I handle client management. I'm now serving more clients with less stress."</p>
                <span className="text-green-700 font-semibold">— David K., Health Coach</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default EbookMagnet; 